import { Table as TableUI } from '@mantine/core';
import styled from 'styled-components';

export const Wrapper = styled(TableUI.Td)`
  flex: 1;
  width: 100px;
`;
